import request from '@/utils/request'
import qs from 'qs'

const getPaperById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-paper/${id}`,
    method: 'get'
  })
}

const getPaperPageList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-paper/page-list`,
    method: 'get',
    params: query,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

const getPaperAll = () => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-paper/paper-all`,
    method: 'get',
  })
}

function createPaper(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-paper`,
    method: 'post',
    data
  })
}

const updatePaper = (id, data) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-paper/${id}`,
    method: 'put',
    data
  })
}
export default {
  createPaper,
  updatePaper,
  getPaperById,
  getPaperPageList,
  getPaperAll
}
